module.exports = __webpack_public_path__ + "assets/img/wx.2a60dd1f.png";